/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationCompanyFlexiproductQuery from '../graphql/queries/GetSimulationCompanyFlexiproductQuery.js';

const useGetSimulationCompanyFlexiproductQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationCompanyFlexiproductQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationCompanyFlexiproduct: R.omit(['__typename'], data?.getSimulationCompanyFlexiproduct_simulation_company || {})
  };
};

export default useGetSimulationCompanyFlexiproductQuery;
